import { colors } from "../colors";

export const androidColors = {
    background: "#FFFFFF",
    label: "#000000",
    paragraph: 'rgba(60, 60, 67, 0.60)',
    primaryText: colors.primaryHighlighted,
    text: colors.text,
}